<template>
  <div class="panel-card-wrapper" :class="{ 'segment-card': isSegmentCard || isScreenList }">
    <div
      class="thumb_page tile"
      :class="{
        selected: isSelected,
        segment,
        'module-list': isModuleList,
      }"
    >
      <div
        class="slide tile__media"
        :class="[{ 'module-list': isModuleList }]"
        :style="backgroundImageMedia"
      >
        <div
          @click="$emit('selected')"
          ref="cardEl"
          class="containerScreen tile__img"
          :class="[{ 'module-list': isModuleList }]"
          :style="{ backgroundImage }"
        >
          <span class="segment-type" v-show="isMultipleLayers">
            <i class="icon-layers"></i>
          </span>
          <span class="close-segment" v-show="isModuleList" @click="$emit('remove-segment')">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background:new 0 0 512 512;"
              xml:space="preserve"
            >
              <path
                d="M437.019,74.981C388.668,26.628,324.378,0,256,0C187.62,0,123.333,26.628,74.981,74.98S0,187.62,0,256
			c0,68.381,26.628,132.668,74.981,181.02C123.332,485.372,187.62,512,255.999,512s132.669-26.628,181.02-74.98
			C485.371,388.667,512,324.38,512,256C512,187.619,485.371,123.332,437.019,74.981z M368.853,347.642
			c5.857,5.857,5.857,15.355,0,21.213c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393L256,277.214
			l-91.641,91.641c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393c-5.858-5.857-5.858-15.355,0-21.213
			l91.64-91.641l-91.64-91.641c-5.858-5.857-5.858-15.355,0-21.213c5.857-5.857,15.354-5.857,21.213,0L256,234.788l91.64-91.641
			c5.857-5.857,15.355-5.857,21.213,0c5.857,5.857,5.857,15.355,0,21.213l-91.641,91.641L368.853,347.642z"
              />
            </svg>
          </span>
          <ul class="actions-wrapper" @click.stop="checkTarget" v-if="!isModuleList">
            <!--<li-->
            <!--v-has-permission="'edit_duration_segment_action'"-->
            <!--:title="$t('panels.screenSettings')"-->
            <!--class="fa fa-cogs item-li li-settings "-->
            <!--@click.stop="showSettingPanel()"-->
            <!--&gt;</li>-->
            <li
              :title="$t('panels.duplicateScreen')"
              class="fa fa-clone item-li li-duplicate "
              @click.stop="$emit('duplicated')"
              :class="{
                disabled:
                  selectedSlides.length >= permission.nb_screen_segment && getNbSreenSegment,
              }"
            ></li>
            <v-popover
              offset="16"
              container="#editor"
              popoverClass="card-tooltip"
              placement="top"
              default-placement="top"
              class="more-actions-btn-parent p-2"
            >
              <!-- This will be the popover target (for the events and position) -->
              <li
                :title="$t('panels.editScreen')"
                class="fa fa-ellipsis-v item-li li-edit more-actions-btn open-menu-style"
              ></li>
              <!-- This will be the content of the popover -->
              <template slot="popover">
                <panel-card-actions
                  :is-segment-card="isSegmentCard"
                  :card="slide"
                  :segment="segment"
                ></panel-card-actions>
              </template>
            </v-popover>
          </ul>
          <div class="duration-wrapper" v-if="!isScreenList">{{ duration | FormatTime }}</div>
          <div
            v-if="!isModuleList"
            class="toggle-slides"
            v-has-permission="'can_toggle_slides_action'"
            v-show="isSegmentCard"
            @click.stop="toggleSegment"
          >
            <i class="icon-arrow-left" :class="{ rotated: isExtended(slide.uid) }"></i>
          </div>
          <!--<div class="num-slide tag">{{ index + 1 }}</div>-->
        </div>
        <div class="slide_name" v-if="!isModuleList">
          <div :id="index" class="tile__title" :title="$t('panels.edit_title')">
            {{ slide.title }}
          </div>
        </div>
      </div>
      <div class="slide_name" v-if="isModuleList">
        <div
          :id="index"
          class="tile__title"
          :class="[{ 'module-list': isModuleList }]"
          :title="$t('panels.edit_title')"
          v-if="paramsClient.nb_screen_segment!==1"
        >
          {{ slide.title }}
        </div>
        <div
          v-if="paramsClient.nb_screen_segment===1 && slide.screens"
          :id="index"
          class="tile__title"
          :class="[{ 'module-list': isModuleList }]"
          :title="$t('panels.edit_title')"
        >
          {{ slide.screens[0].title }}
        </div>

      </div>
    </div>
    <button
      v-if="!isModuleList"
      type="button"
      class="btn btn-sm add-segment-btn"
      v-show="isSegmentCard"
      @click.stop="$emit('insertSegment')"
    >
      + Segment
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HasPermission from '../../core/directives/HasPermission.js';
import PanelCardActions from './PanelCardActions';
import mixin from '../../mixins/Mixin.js';

export default {
  name: 'PanelCard',
  components: {
    PanelCardActions,
  },
  props: {
    segment: Object,
    slide: Object,
    index: Number,
    isSelected: Boolean,
    removable: Boolean,
    showVideoIntro: Object,
    isModuleList: {
      type: Boolean,
      default: false,
    },
    isScreenList: {
      type: Boolean,
      default: false,
    },
    isSegmentCard: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    HasPermission,
  },
  data() {
    return {
      isToggled: false,
      title: this.slide.title,
    };
  },
  mixins: [mixin],
  created() {},
  mounted() {},
  watch: {
    slide: {
      handler(val) {
        this.title = val.title;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      hasVideoIntro: 'slides/getHasVideoIntro',
      currentSlide: 'slides/getCurrent',
      permission: 'getPermissions',
      selectedSlides: 'slides/getSelected',
      isExtended: 'segments/isExtended',
      paramsClient: 'getParamsClients',

    }),
    duration() {
      return this.isSegmentCard ? this.slide.duration : this.slide.options.duration;
    },
    isMultipleLayers() {
      return (
        this.isSegmentCard &&
        !this.isModuleList &&
        this.slide.screens.filter(s => s.type !== 'startGeneric').length > 1
      );
    },
    backgroundImage() {
      if (!this.isModuleList) {
        if (this.isSegmentCard) {
          const firstScreen = this.slide.screens.find(
            s => !s.type.toLowerCase().includes('generic'),
          );
          if (firstScreen && firstScreen.screenShot) {
            return `url(${firstScreen.screenShot})`;
          }
        }
        return `url(${this.slide.screenShot || this.defaultScreenshot})`;
      }
    },
    backgroundImageMedia() {
      if (this.isModuleList) {
        if (this.isSegmentCard) {
          const firstScreen = this.slide.screens.find(
            s => !s.type.toLowerCase().includes('generic'),
          );
          if (firstScreen && firstScreen.screenShot) {
            return {
              'background-image': `url(` + firstScreen.screenShot + `)`,
            };
          }
        }
        return {
          'background-image': 'url(' + this.slide.screenShot || this.defaultScreenshot + ')',
        };
      }
    },
  },
  methods: {
    ...mapActions('slides', ['updateSlideTitle']),

    checkTarget(event) {
      if (
        !(
          event.target.classList.contains('more-actions-btn') ||
          event.target.parentNode.classList.contains('more-actions-btn-parent')
        )
      ) {
        this.$refs.cardEl.click();
      }
    },
    toggleSegment() {
      this.isToggled = !this.isToggled;
      this.$emit('toggled');
    },
    update() {
      this.updateSlideTitle({ title: this.title, uid: this.slide.uid });
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
      this.toggleEditMode();
    },
    showSettingPanel() {
      this.$emit('selected');
      setTimeout(() => {
        const barsEl = document.querySelector('#gjs .gjs-pn-buttons .fa-bars');
        const brushEl = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush');
        const decorationTitleEl = document.querySelector(
          '#gjs-sm-decoration:not(.gjs-sm-open) .gjs-sm-title',
        );
        const durationTitleEl = document.querySelector('#gjs .gjs-sm-sector .gjs-sm-title');

        barsEl.click();
        const bodyTitleEl = document.querySelector('#gjs .gjs-layer-title');
        bodyTitleEl.click();

        brushEl.click();
        if (decorationTitleEl) {
          decorationTitleEl.click();
          durationTitleEl.click();
        }
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
$duration: 0.3s;
$tileWidth: 144px;
$tileHeight: $tileWidth / (16 / 9);
$iconSize: 40px;
$growFactor: 1.05;
$moveLeft: -($tileWidth * ($growFactor - 1) / 2);
$moveRight: $tileWidth * ($growFactor - 1);

.card-wrapper:not(.extended),
.panel-card-wrapper:not(.segment-card) {
  .thumb_page {
    &:hover {
      .actions-wrapper {
        opacity: 1;
        visibility: visible;
      }
      .tile__img {
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
      }
    }
  }
}

.tile {
  position: relative;
  display: inline-block;
  margin-right: 18px;
  font-size: 20px;
  cursor: pointer;
  &:not(.module-list) {
    transition: 0.3s ease-in-out;
    transform-origin: center;
    margin-left: 8px;
    &:hover {
      transform: scale($growFactor);
    }
    &.selected {
      transform: scale(1.1);
      margin-right: 30px;
      box-shadow: 0 0 0 2px #1a93f0;
      border-radius: 3px;
      margin-bottom: -5px;
    }
    .li-duplicate {
      &.disabled {
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.3;
      }
    }
  }
  &__title {
    width: $tileWidth;
    font-weight: bold;
    text-align: left;
    padding: 0.5em;
    color: #ffffff;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
    height: 4em;
    top: 0;
    font-size: 13px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:not(.module-list) {
      position: absolute;
    }
    &.module-list {
      background: none;
      height: auto;
      color: #707070;
      padding: 0.5em 0;
    }
  }
  &__media {
    border-radius: 3px;
    &.module-list {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
    .segment-type {
      position: absolute;
      right: 0;
      margin: 8px;
      font-size: 0.8em;
      z-index: 2;
      color: #ffffff;
    }
    .close-segment {
      position: absolute;
      right: -11px;
      /* margin: 8px; */
      font-size: 0.8em;
      z-index: 6;
      color: #ffffff;
      top: -11px;
      svg {
        width: 20px;
        height: 20px;
      }
    }
    .duration-wrapper {
      position: absolute;
      bottom: 0;
      font-size: 0.6em;
      z-index: 2;
      color: #1a93f0;
      font-weight: 700;
      margin: 2px 6px;
    }
    .toggle-slides {
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 3;
      font-size: 0.6em;
      background-color: #1a93f0;
      font-weight: 700;
      padding: 3px 6px;
      border-top-left-radius: 3px;
      border-bottom-right-radius: 3px;
      color: #ffffff;
      cursor: pointer;
      i {
        transform: rotate(180deg);
        transition: all 0.3s ease-in-out;
        display: inline-block;
        &.rotated {
          transform: rotate(0);
        }
      }
    }
  }
  &__img {
    width: $tileWidth;
    height: $tileHeight;
    background-size: cover;
    background-position: center;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
    border-radius: 3px;
    position: relative;
    .actions-wrapper {
      margin: 0 !important;
      padding: 0 !important;
      display: flex;
      align-items: center;
      justify-content: space-around;
      list-style-type: none;
      background-color: rgba(0, 0, 0, 0.6);
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      visibility: hidden;
      transition: 0.3s ease-in-out;
      border-radius: 3px;
      font-size: 15px;
      z-index: 1;
    }
    &.module-list {
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
      &:hover {
        border: 2px solid #2196f3 !important;
        border-radius: 2px;
        /*transition: none;*/
        .close-segment {
          display: block !important;
        }
      }
    }
  }
  &__details {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    font-size: 10px;
    opacity: 0;
    transition: $duration opacity;
  }
}

.num-slide {
  font-size: 12px;
  position: absolute;
  top: -7px;
  right: -10px;
  background: #f44336;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  padding: 1px;
  color: white;
  font-weight: 700;
  z-index: 1;
}

.li-delete {
  color: #f44336;
}
.open-menu-style {
  background: #8d8d8d;
  color: white !important;
  border: 1px solid #8d8d8d;
  border-radius: 100%;
  padding: 2px;
  &.fa-ellipsis-v {
    transform: rotate(90deg);
  }
}
.panel-card-wrapper {
  height: 90px;
  padding-right: 0;
  position: relative;
  transition: padding-right 0.3s ease-in-out;
  .add-segment-btn {
    position: absolute;
    padding: 3px !important;
    font-size: 1em !important;
    transform: translateY(-50%);
    right: 0;
    top: 50%;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.3s ease-in-out, opacity 0.3s ease-in-out;
    margin-right: 6px !important;
    color: #ffffff !important;
    background-color: #2196f3 !important;
    border: none !important;
    border-radius: 12px !important;
  }
  .panel-cards-transitions {
    display: flex;
    flex-direction: row;
  }
  &.segment-card:hover {
    padding-right: 70px;
    .add-segment-btn {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PanelCard.vue?41aea991